var map = {
	"./CabinetT1 ded.png": "./src/assets/objectIcons/CabinetT1 ded.png",
	"./ClourureT1 ded.png": "./src/assets/objectIcons/ClourureT1 ded.png",
	"./building.png": "./src/assets/objectIcons/building.png",
	"./building02.png": "./src/assets/objectIcons/building02.png",
	"./cabinet.png": "./src/assets/objectIcons/cabinet.png",
	"./cabinet_t1.png": "./src/assets/objectIcons/cabinet_t1.png",
	"./cabinet_t2.png": "./src/assets/objectIcons/cabinet_t2.png",
	"./cabinet_t3.png": "./src/assets/objectIcons/cabinet_t3.png",
	"./cabinet_t4.png": "./src/assets/objectIcons/cabinet_t4.png",
	"./chamber.png": "./src/assets/objectIcons/chamber.png",
	"./closure.png": "./src/assets/objectIcons/closure.png",
	"./closure_t1.png": "./src/assets/objectIcons/closure_t1.png",
	"./closure_t2.png": "./src/assets/objectIcons/closure_t2.png",
	"./closure_t3.png": "./src/assets/objectIcons/closure_t3.png",
	"./closure_t4.png": "./src/assets/objectIcons/closure_t4.png",
	"./manhole.png": "./src/assets/objectIcons/manhole.png",
	"./nro.png": "./src/assets/objectIcons/nro.png",
	"./pm.png": "./src/assets/objectIcons/pm.png",
	"./pole.png": "./src/assets/objectIcons/pole.png",
	"./technical local fdp.png": "./src/assets/objectIcons/technical local fdp.png",
	"./technical local mdu.png": "./src/assets/objectIcons/technical local mdu.png",
	"./technical local olt.png": "./src/assets/objectIcons/technical local olt.png"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/objectIcons recursive ^\\.\\/.*\\.png$";


//////////////////
// WEBPACK FOOTER
// ./src/assets/objectIcons ^\.\/.*\.png$
// module id = ./src/assets/objectIcons recursive ^\.\/.*\.png$
// module chunks = 1